import { Box, Button, Card, Container, Typography, useMediaQuery, useTheme } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutlineOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import ErrorPageImage from '../../assets/images/error_page_image.png';

export default function ErrorPage(): React.JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  const handleContactSupport = (): void => {
    window.Intercom('show');
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Card
        sx={{
          width: {
            xs: 364,
            sm: 500,
          },
          textAlign: 'center',
          p: 0,
        }}
      >
        <Box
          component="img"
          sx={{ width: '100%' }}
          src={ErrorPageImage}
        />
        <Box sx={{ px: 2, mt: 2, mb: 1 }}>
          <Typography variant={isXs ? 'titleLarge' : 'headlineSmall'}>
            {t('error:an_error_occured')}
          </Typography>
          <Typography variant={isXs ? 'bodySmall' : 'bodyMedium'} color="onSurfaceVariant" sx={{ mt: 0.5, whiteSpace: 'pre-wrap' }}>
            {t('error:an_error_occured_description')}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: {
                xs: 'column-reverse',
                sm: 'row',
              },
              justifyContent: 'center',
              gap: 1,
              py: 2,
            }}
          >
            <Button
              variant="outlined"
              startIcon={<HelpOutlineIcon />}
              onClick={handleContactSupport}
            >
              {t('error:contact_support')}
            </Button>
            <Button
              variant="contained"
              startIcon={<LoginOutlinedIcon />}
              onClick={() => navigate('/')}
            >
              {t('error:back_to_home_page')}
            </Button>
          </Box>
        </Box>
      </Card>
    </Container>
  );
}
